const host = window.location.hostname;
const protocol = window.location.protocol;
const injectedConfig = window.__VROCS_CONFIG__ || {};
const viteEnv = import.meta.env || {};

function detectEnvironment() {
  if (injectedConfig.environment) return injectedConfig.environment;
  if (viteEnv.VITE_VROCS_ENV) return viteEnv.VITE_VROCS_ENV;
  if (host === "staging.vrocks.me") return "staging";
  if (host === "vrocks.me" || host === "www.vrocks.me") return "production";
  return "development";
}

function detectNativeRuntime() {
  return Boolean(window.Capacitor?.isNativePlatform?.() || protocol === "capacitor:");
}

function resolveApiBaseUrl() {
  if (injectedConfig.apiBaseUrl) return injectedConfig.apiBaseUrl;
  if (viteEnv.VITE_API_BASE_URL) return viteEnv.VITE_API_BASE_URL;
  if (window.VROCS_API_URL) return window.VROCS_API_URL;
  if (detectNativeRuntime() || protocol === "file:") return "https://api.vrocks.me";
  return `${window.location.origin}/api`;
}

export const runtimeConfig = Object.freeze({
  environment: detectEnvironment(),
  buildVersion: injectedConfig.buildVersion || viteEnv.VITE_BUILD_VERSION || "mvp245",
  apiBaseUrl: resolveApiBaseUrl().replace(/\/$/, ""),
  isNative: detectNativeRuntime(),
  map: Object.freeze({
    styleUrl: injectedConfig.map?.styleUrl || viteEnv.VITE_MAP_STYLE_URL || "https://tiles.openfreemap.org/styles/bright",
    rasterTiles: injectedConfig.map?.rasterTiles || viteEnv.VITE_MAP_RASTER_TILES || "/tiles/osm/{z}/{x}/{y}.png",
    vectorTiles: injectedConfig.map?.vectorTiles || viteEnv.VITE_MAP_VECTOR_TILES || "https://tiles.openfreemap.org/planet",
    terrainTiles: injectedConfig.map?.terrainTiles || viteEnv.VITE_MAP_TERRAIN_TILES || "https://tiles.mapterhorn.com/tilejson.json"
  })
});

window.VROCS_CONFIG = runtimeConfig;
